// https://en.wikipedia.org/wiki/International_vehicle_registration_code

const vehicleCountries = {
  fr: 'F', // France

  be: 'B', // Belgique
  de: 'D', // Allemagne
  lu: 'L', // Luxembourg
  uk: 'GB', // Royaume-Uni

  at: 'A', // Autriche
  bg: 'BG', // Bulgarie
  cy: 'CY', // Chypre
  hr: 'HR', // Croatie
  dk: 'DK', // Danemark
  es: 'E', // Espagne
  ee: 'EST', // Estonie
  fi: 'FIN', // Finlande
  el: 'GR', // Grèce
  hu: 'H', // Hongrie
  ie: 'IRL', // Irlande
  it: 'I', // Italie
  lv: 'LV', // Lettonie
  lt: 'LT', // Lituanie
  mt: 'M', // Malte
  nl: 'NL', // Pays-Bas
  pl: 'PL', // Pologne
  pt: 'P', // Portugal
  cz: 'CZ', // Tchéquie
  ro: 'RO', // Roumanie
  sk: 'SK', // Slovaquie
  si: 'SLO', // Slovénie
  se: 'S', // Suède
  al: 'AL', // Albanie
  mk: 'NMK', // Macédoine du Nord
  me: 'MNE', // Monténégro
  rs: 'SRB', // Serbie
  ba: 'BIH', // Bosnie-Herzégovine
  is: 'IS', // Islande
  no: 'N', // Norvège
  ch: 'CH', // Suisse
  md: 'MD', // Moldavie
};

export default vehicleCountries;
